import axios from "axios";
import { initializeApp } from "firebase/app";
import "firebase/auth";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import "firebase/database";
import { getDatabase } from "firebase/database";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const firebase = initializeApp(config);

// export const auth = firebase.auth();
export const realTime = getDatabase(firebase);

export const auth = getAuth(firebase);

export function onAuthStateChange(callback) {
  console.log("CALL BACK", callback);
  onAuthStateChanged(auth, (user) => {
    console.log("USER ", user);
    // setTimeout(() => {
    // }, 5000);
    if (user) {
      console.log("login");
      callback({ loggedIn: true, email: user.email });
    } else {
      console.log("not login");
      callback({ loggedIn: false });
    }
  });
}
export async function onPermissionCheck() {
  var provider = new firebase.auth.GoogleAuthProvider();

  let currenToken = localStorage.getItem("csrfToken");
  provider.addScope("https://www.googleapis.com/auth/gmail.send");
  provider.addScope("https://www.googleapis.com/auth/gmail.compose");
  provider.addScope(" https://www.googleapis.com/auth/gmail.modify");
  provider.addScope(" https://mail.google.com");
  // let resultPermisos = await firebase.auth().signInWithPopup(provider);

  let resultToken = await axios.post(
    `${process.env.REACT_APP_REDIRECT_BASE}/verifySessionCookie`,
    {},
    {
      withCredentials: true,
      crossDomain: true,
      params: {
        _csrf: currenToken,
      },
    }
  );
  // console.log(resultToken)
  // if (resultToken.data.token) {
  //   firebase.auth().signInWithCustomToken(resultToken.data.token);
  // }
  console.log(resultToken);
  console.log(firebase.auth().currentUser);
  resultToken["user"] = firebase.auth().currentUser;
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(resultToken);
    }, 1500);
  });
}
